import RootRoutes from './routes/RootRoutes';
import theme from './config/theme';
import { useEffect, useState } from 'react';
import Images from 'assets/images';
import { CustomProvider } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import { esES } from 'rsuite/esm/locales';
import { refreshSessionTimeService } from 'services/security/userServices';

function App() {
  const [ready, setReady] = useState(false)

  useEffect(() => {
    let link = document.querySelector("link[rel~='icon']");
    try {
      link.href = Images[theme.title.toLocaleLowerCase()].favicon;
    } catch (e) { 
      link.href = Images[theme.code.toLocaleLowerCase()].favicon;
    }
    document.title = theme.title;
    if (!document.location.href.includes("?session_expired"))
      refreshSessionTimeService().catch(() => { }).finally(() => setReady(true))
    else
      setReady(true)
  }, []);

  return (
    ready ? <div className='bg'>
      <CustomProvider theme="light" locale={esES}>
        <RootRoutes />
      </CustomProvider>
    </div> : <div id={'loading'} className='loading-screen'>
      <img src={Images.icon.loading} alt='loading' />
    </div>
  );
}

export default App;
